module.exports = __webpack_public_path__ + "assets/icons/ic_error_outline-98b3.svg";